import AppFlowActions from '../../constants';

const displayLoading = data => ({ type: AppFlowActions.DISPLAY_LOADING, data });

export default displayLoading;
